module.exports = __webpack_public_path__ + "static/media/fetch.bfa81961.png";